import {
  Component,
  ElementRef,
  Renderer2,
  OnInit,
  OnDestroy,
  ChangeDetectorRef,
  Output,
  Inject,
  PLATFORM_ID,
  inject,
} from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  faList,
  faXmark,
  faWallet,
  faEllipsisV,
  faBell,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { SidebarService } from '../../Services/sidebar-service.service';
import { LogoutmodelComponent } from './logoutmodel/logoutmodel.component';
import { deleteaccountmodelComponent } from './deleteaccountmodel/deleteaccountmodel.component';
import { WebSocketService } from '../../Services/web-socket.service';
import { NotificationsComponent } from '../notifications/notifications.component';
import { ApiCallService } from '../../Services/api-call-service.service';
import { LoaderService } from '../../Services/loader-service.service';
import { Subject, takeUntil } from 'rxjs';
import { json } from 'stream/consumers';
import { UtilsService } from '../../Services/utils.service';
import { LoaderComponent } from '../loader/loader.component';
import { MusicService } from '../../Services/music.service';
import { ErrorhandlingService } from '../../Services/error-handling.service';
import { NotificationService } from '../../Services/notification.service';
import { EventEmitter } from '@angular/core';
import { GameService } from '../../Services/game.service';
import { kycformComponent } from '../../pages/landing-page/kyc-form/kyc-form.component';
import { KycPopupComponent } from '../../common/kyc-popup/kyc-popup.component';
import { PwaInstallService } from '../../Services/pwa-install.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    LogoutmodelComponent,
    NotificationsComponent,
    deleteaccountmodelComponent,
    LoaderComponent,
    KycPopupComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  isMuted: boolean = false;
  private clickListener!: () => void;
  private toastr = inject(ToastrService);
  public pwaInstall = inject(PwaInstallService);
  username: string | null = '';
  dots = faEllipsisV;
  user = faUser;
  cross = faXmark;
  bell = faBell;
  Wallet = faWallet;
  CrossIcon = false;
  isOpen = false;
  isLogoutModalOpen = false;
  isdeleteaccountmodelopen = false;
  islogin = false;
  isDropdownOpen = false;
  kycVerfication: string | null = '';

  profileImage = 'https://cmax-2.pages.dev/assets/icons/profileimage.png';
  notifications: any[] = []; // Ensure notifications is an array
  showAlert: boolean = true; // Flag to control alert visibility
  @Output() openChatFromHeader = new EventEmitter<void>();
  @Output() openAuth = new EventEmitter<'login' | 'signup'>();

  closeAlert() {
    this.showAlert = false; // Set the flag to false to hide the alert
  }
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
    private router: Router,
    private sidebarService: SidebarService,
    private _socketService: WebSocketService,
    private apiCallService: ApiCallService,
    private loaderService: LoaderService,
    private utilService: UtilsService,
    private Ref: ChangeDetectorRef,
    private musicService: MusicService,
    // private GameService: GameService,
    private _errorHandleService: ErrorhandlingService,
    private notificationService: NotificationService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // if (typeof window !== 'undefined' && window.localStorage) {
    // }
    //check the router for dashboard route and landing route
    this.isDashboardRoute();
    this.isLandingRoute();
    this.isMuted = this.musicService.isMusicMuted();
    if (this.router.url.startsWith('/VerifyPayment')) {
      this.isNotLoginBtnShown = true;
    }
    // this.walletAmount = this.GameService.balance;
    this.getKYCVerification();
  }
  isNotLoginBtnShown: boolean = false;

  async installApp(): Promise<void> {
    const result = await this.pwaInstall.promptInstall();

    if (result === 'unavailable') {
      this.toastr.info(
        'To install: open your browser menu (⋮ or …) → "Install app" or "Add to Home Screen".',
        'Install Casinoze',
        { timeOut: 6000, positionClass: 'toast-top-center' }
      );
    } else if (result === 'accepted') {
      this.toastr.success('App installed successfully!', 'Casinoze', { timeOut: 3000 });
    }
  }

  toggleMusic() {
    this.musicService.muteUnmute();
    this.isMuted = this.musicService.isMusicMuted();
  }

  toggleSidebar(event: MouseEvent) {
    // this.sidebarService.toggleSidebar();
    event.stopPropagation(); // Prevent the click from bubbling up
    this.sidebarService.toggleSidebar(); // Use the service to toggle the sidebar

    this.showNotifications = false;
    this.isDropdownOpen = false;
    // this.CrossIcon = !this.CrossIcon;
    this.Ref.detectChanges();
  }

  private destroy$ = new Subject<void>();
  showKycPopup = false;

  ngOnInit() {
    // this is handlined by local storage
    //     const storedNotifications = localStorage.getItem('notifications');
    // if (storedNotifications) {
    //   this.notifications = JSON.parse(storedNotifications);
    //   this.notificationCount = this.notifications.length;
    // }
    this.notificationService.notifications$.subscribe((notifs) => {
      this.notifications = notifs;
      this.notificationCount = notifs.length;
      this.Ref.detectChanges();
    });
    // Load notifications on login/dashboard
    const currentUrl = this.router.url;
    if (currentUrl !== '/dashboard' && currentUrl !== '/') {
      this.notificationService.loadNotifications(true);
    }

    //? Profile Image Dynamic Update
    this.utilService.profileImage$.subscribe((image) => {
      this.profileImage = image;
    });

    if (typeof window !== 'undefined' && window.localStorage) {
      const token = localStorage.getItem('token');
      if (this._socketService.isConnected == false && token) {
        this._socketService.connect();
        this.getHeaderValue();
        this.getWalletBalance();
      }
    }
    this.loaderService
      .getTriggerObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getHeaderValue();
      });
    this.loaderService
      .getTriggerWalletObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getWalletBalance();
      });
    this.utilService
      .getTriggerWalletObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getWalletBalance();
      });
    this.utilService
      .getTriggerLogoutObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.logout();
      });
    this.utilService
      .getTriggerKYCHeaders()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getHeaderValue();
        this.getKYCVerification();
      });
    this.clickListener = this.renderer.listen('window', 'click', (e: Event) => {
      const target = e.target as Node;
      if (
        target instanceof Node &&
        !this.elementRef.nativeElement.contains(target)
      ) {
        this.isDropdownOpen = false;
      }
    });

    this.kycVerfication = localStorage.getItem('KYC');
  }

  closeKycPopup() {
    this.showKycPopup = false;
  }
  walletAmount: number = 0; // Example - you’ll set this dynamically from API

  ngOnDestroy() {
    // this.destroy$.next();
    // this.destroy$.complete();
    if (this.clickListener) {
      this.clickListener();
    }
  }

  login() {
    this.islogin = !this.islogin;
    if (this._socketService.isConnected == false) {
      this._socketService.connect();
    }
  }
  logout() {
    localStorage.clear();
    this._socketService.close();
    this.router.navigate(['/']);
    this.utilService.toggleComponentVisibility(false);
    // if (this._socketService.isConnected) {
    // }
    this.closeLogoutModal();
  }

  showLogoutModal() {
    this.isLogoutModalOpen = true;
    this.isDropdownOpen = !this.isDropdownOpen;
  }
  showDeleteaccountmodel() {
    this.isdeleteaccountmodelopen = true;
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  closeLogoutModal() {
    this.isLogoutModalOpen = false;
  }

  closedeleteaccountmodal() {
    this.isdeleteaccountmodelopen = false;
  }
  deleteaccount(userpassword: string) {
    this.loaderService.show();
    const payload = {
      email: localStorage.getItem('email'),
      password: userpassword,
    };
    this.apiCallService
      .PostCallWithToken(payload, 'User/DeleteMoblieUser')
      .subscribe(
        (response) => {
          if (response && response.responseCode === 200) {
            this.logout();
            this.closeLogoutModal();
            this.loaderService.hide();
          } else {
            this._errorHandleService.handleResponseError(response);
            // console.log('User Deletion Failed', response);
          }
          this.loaderService.hide();
        },
        (error) => {
          // console.error('User Deletion Failed', error);
          this._errorHandleService.handleHttpError(error);
          this.loaderService.hide();
          // this.toastr.error('An error occurred during login. Please try again.');
        }
      );
  }

  isDashboardRoute(): boolean {
    return (
      this.router.url.includes('dashboard') &&
      !this.router.url.includes('login') &&
      !this.router.url.includes('SignUp')
    );
  }
  isMobileMenuOpen = false;

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  isLandingRoute(): boolean {
    return (
      this.router.url.includes('login') ||
      this.router.url.includes('SignUp') ||
      this.router.url === '/'
    );
  }
  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isDropdownOpen = !this.isDropdownOpen;
    this.showNotifications = false;
  }

  isAuthRoute(): boolean {
    const currentRoute = this.router.url;
    return currentRoute.includes('/login') || currentRoute === '/SignUp';
  }
  showNotifications = false;

  // toggleNotifications() {
  //   this.showNotifications = !this.showNotifications;
  // }

  // toggleNotifications() {
  //   if (!this.showNotifications) {
  //     this.showNotifications = true;
  //     this.isDropdownOpen = false;
  //     // this.sidebarService.toggleSidebar();
  //   } else {
  //     this.showNotifications = false;
  //   }
  // }

  notificationCount: number = 0; // Store notification count
  receiveNotificationCount(event: number) {
    this.notificationCount = event;
  }

  // toggleNotifications() {
  //   if (!this.showNotifications) {
  //     this.showNotifications = true;
  //     this.isDropdownOpen = false;
  //     // Optionally refresh notifications here
  //     this.apiCallService.GetCallWithToken('NotificationMessages/GetAllNotifications?PageNumber=1&PageSize=10')
  //       .subscribe((notifResponse) => {
  //         if (notifResponse && notifResponse.responseCode === 200) {
  //           this.notifications = notifResponse.data;
  //           this.notificationCount = this.notifications.length;
  //           localStorage.setItem('notifications', JSON.stringify(this.notifications));
  //         }
  //       });
  //   } else {
  //     this.showNotifications = false;
  //   }
  // }
  // Update notification count from child component
  updateNotificationCount(count: number) {
    this.notificationCount = count;
  }
  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
    if (this.showNotifications && this.notifications.length === 0) {
      this.notificationService.loadNotifications(true);
    }
  }

  getHeaderValue() {
    this.checkAndRequest();
    const payload = `User/GetHeaderValues`;
    this.apiCallService.GetCallWithToken(payload).subscribe(
      (response) => {
        if (response && response.responseCode === 200) {
          // Bind the header values from the API response
          // this.nameInitials = response.data.nameInitals || '';
          // this.profileImage = response.data.profileImage || '';
          this.profileImage = response.data.profileImage
            ? response.data.profileImage
            : 'https://cmax-2.pages.dev/assets/icons/profileimage.png';

          //? Set Profile Image For Dynamic Update
          this.utilService.setProfileImage(this.profileImage);

          this.username = response.data.userName || '';
          localStorage.setItem('userName', response.data.userName);
          localStorage.setItem('code', response.data.referralCode);
          localStorage.setItem('KYC', response.data.kycStatus);
          this.kycVerfication = response.data.kycStatus;

          localStorage.setItem('profileImage', this.profileImage);
          // this.loaderService.hide();
        } else if (response && response.responseCode === 400) {
          // console.error(
          //   'Failed to fetch header values',
          //   response.responseMessage
          // );
          this.loaderService.hide();
        } else {
          // console.error('Unexpected response', response);
          this.loaderService.hide();
        }
      },
      (error) => {
        // console.error('Error fetching header values', error);
        this.loaderService.hide();
      }
    );
  }

  saveUserProfileImage() {
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';

    fileInput.onchange = async (event: Event) => {
      const file = (event.target as HTMLInputElement)?.files?.[0];

      if (file) {
        try {
          // Show loader while processing
          this.loaderService.show();

          // Convert the file to a base64 string
          const base64Image = await this.convertFileToBase64(file);

          // Create the API payload
          const payload: any = {
            base64Image: base64Image,
          };

          // Make the API call
          this.apiCallService
            .PostCallWithToken(payload, 'User/SaveUserProfileImage')
            .subscribe(
              (response) => {
                if (response && response.responseCode === 200) {
                  this.profileImage = base64Image;

                  //? Set Profile Image for Dynamic Update
                  this.utilService.setProfileImage(base64Image);

                  this.getHeaderValue();
                  this.isDropdownOpen = false;
                  // console.log(
                  //   'Profile image saved successfully:',
                  //   response.responseMessage
                  // );
                } else {
                  // console.error(
                  //   'Failed to save profile image:',
                  //   response.responseMessage
                  // );
                }
                this.loaderService.hide();
              },
              (error) => {
                // console.error('Error saving profile image:', error);
                this.loaderService.hide();
              }
            );
        } catch (error) {
          // console.error('Error processing image file:', error);
          this.loaderService.hide();
        }
      }
    };

    // Trigger the file picker dialog
    fileInput.click();
  }

  // Delete User Profile Image
  deleteUserProfileImage() {
    this.loaderService.show();

    this.apiCallService
      .PostCallWithToken({}, 'User/DeleteUserProfileImage')
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            this.profileImage = '';
            this.utilService.setProfileImage('');
            this.loaderService.triggerFunction();
          } else {
            this._errorHandleService.handleResponseError(response);
          }
        },
        error: (error) => {
          this._errorHandleService.handleHttpError(error);
        },
        complete: () => {
          this.loaderService.hide();
        },
      });
  }

  private convertFileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  redirecttochngPass() {
    this.router.navigate(['dashboard/changePass']);
  }

  redirecttoTermsConditions() {
    this.router.navigate(['dashboard/Terms&Conditions']);
  }
  redirectToHelpSupport() {
    this.router.navigate(['dashboard/help-support']);
  }
  redirectToKYCform() {
    this.router.navigate(['dashboard/KYCform']);
  }

  RedirectToWallet() {
    // this._errorHandleService.showModalSubject.next(true);
    this.loaderService?.triggerWalletFunction();
    this.router.navigate(['dashboard/wallet']);
  }
  openWalletModal() {
    this._errorHandleService.showModalSubject.next(true);
    // this.loaderService?.triggerWalletFunction();
    // this.router.navigate(['dashboard/wallet']);
  }
  redirectToLogin() {
    this.router.navigate(['login']);
  }

  isShowBanner(): boolean {
    // this.router.url == '/';
    return false;
  }

  isShowBannerExceptHome(): boolean {
    return this.router.url != '/';
  }
  openDeleteLink() {
    window.open('http://154.38.171.150:8046/Delete-Customer', '_blank');
  }

  isScreenWidthLessThan800(): boolean {
    return typeof window !== 'undefined' && window.innerWidth < 800;
  }

  get isLoggedIn(): boolean {
    return typeof window !== 'undefined' && !!localStorage.getItem('token');
  }

  openJoinNow(): void {
    if (this.openAuth.observed) {
      this.openAuth.emit('signup');
    } else {
      this.router.navigate(['/SignUp']);
    }
  }

  OpenDownload() {
    this.loaderService.show();

    this.apiCallService.GetCallWithToken('AppVersion/GetAppVersion').subscribe(
      (response) => {
        if (response && response.responseCode === 200) {
          const filePath = response?.data?.appUpdateUrl;

          // Create a temporary link element
          const link = document.createElement('a');
          link.href = filePath; // Path relative to the app's root
          link.download = 'social.apk'; // Set the downloaded file name
          link.target = '_blank'; // Open in a new tab (optional)

          // Trigger the download
          link.click();

          // Clean up the temporary link element
          link.remove();
          this.loaderService.hide();
        } else {
          this._errorHandleService.handleResponseError(response);
          this.loaderService.hide();
        }
      },
      (error) => {
        this._errorHandleService.handleHttpError(error);
      }
    );
  }
  handleOpenChat() {
    //  console.log('Header: openChatFromHeader emitted');
    this.openChatFromHeader.emit();
  }

  WalletPayload() {
    return {
      customerId: Number(localStorage.getItem('customerId')),
      pageNumber: 1,
      pageSize: 10,
      searchText: '',
      startDate: '',
      endDate: '',
    };
  }
  //   getWalletBalance(pageNumber: number = 1, searchText: string = '') {
  //     this.loaderService.show();
  //     const CustomerID = localStorage.getItem('customerId');
  //     // let payload = `Wallet/GetWalletBalance?CustomerId=${CustomerID}&PageNumber=${pageNumber}&PageSize=${10}`;
  //     let payload = this.WalletPayload();

  //     // if (searchText.trim()) {
  //     //   payload += `&SearchText=${encodeURIComponent(searchText.trim())}`;
  //     // }

  //     this.apiCallService.PostCallWithToken(payload, 'Wallet/GetWalletBalance').subscribe(

  getWalletBalance(pageNumber: number = 1) {
    const CustomerID = localStorage.getItem('customerId');
    // const payload = `Wallet/GetWalletBalance?CustomerId=${CustomerID}&PageNumber=${pageNumber}&PageSize=${10}`;
    const payload = this.WalletPayload();
    this.apiCallService
      .PostCallWithToken(payload, 'Wallet/GetWalletBalance')
      .subscribe(
        (response) => {
          if (response && response.responseCode == 200) {
            // this.walletAmount =
            //   response.data.totalBalance === ''
            //     ? this.walletAmount
            //     : parseFloat(response.data.totalBalance);
            this.walletAmount = response.data.totalBalance === ''
              ? this.walletAmount
              : Math.floor(parseFloat(response.data.totalBalance) || 0);
          } else {
            // console.log('Data fetch failed', response);
            // this.loaderService.hide();
            this._errorHandleService.handleResponseError(response);
          }
        },
        (error) => {
          // console.error('Data fetch error', error);
          // this.loaderService.hide();
          this._errorHandleService.handleHttpError(error);
        }
      );
  }
  isTreasurePickRoute(): boolean {
    const current = this.router.url;
    return (
      current === '/dashboard/TreasurePick' ||
      current === '/dashboard/Avaitar' ||
      current === '/dashboard/Baccaret' ||
      current === '/dashboard/Roulette' ||
      current === '/dashboard/StackBuilder' ||
      current === '/dashboard/Keno' ||
      current === '/dashboard/Mines' ||
      current === '/dashboard/Plinko' ||
      current === '/check' ||
      current === '/checkpay'
    );
  }

  // ///////////Api Call For KYC Form Header Value/////////

  KycValues: any;
  getKYCVerification() {
    const CustomerID = localStorage.getItem('customerId');
    this.apiCallService
      .GetCallWithToken('KYC/GetCustomerKYCStatus?CustomerId=' + CustomerID)
      .subscribe(
        (response) => {
          if (response && response.responseCode == 200) {
            this.KycValues = response.data;
            this.utilService.setData(this.KycValues, true);
          } else {
            //this._errorHandleService.handleResponseError(response);
          }
        },
        (error) => {
          //this._errorHandleService.handleHttpError(error);
        }
      );
  }


  showRefralModal: boolean = false;
  // referralLink = "https://highrollers.game/SignUp?refral= ";
  buttonText = "COPY LINK";
  private readonly baseUrl = "https://highrollers.game/SignUp?refral=";
  get referralLink(): string {
    const code = localStorage.getItem('code') || '';
    return `${this.baseUrl}${encodeURIComponent(code)}`;
  }
  copyToClipboard() {
    navigator.clipboard.writeText(this.referralLink).then(() => {
      this.buttonText = "COPIED!";
      setTimeout(() => this.buttonText = "COPY LINK", 2000);
    });
  }

  closeReferal() {
    this.showRefralModal = false;
  }
  openrefral() {
    this.showRefralModal = true;
    this.getReferalbonus();
  }
  refPercentage: any
  refCount: any
  getReferalbonus() {
    this.apiCallService
      .GetCallWithoutToken('User/Getreferralbonus')
      .subscribe({
        next: (response) => {
          if (response.responseCode === 200 && response.data) {
            const data = response.data;
            // Safely find the specific objects based on PaymentName
            const percentageObj = data.find((item: any) => item.PaymentName === 'referralpercentage');
            const countObj = data.find((item: any) => item.PaymentName === 'referralcount');
            // Assign the values if found, otherwise default to 0
            this.refPercentage = percentageObj ? percentageObj.Bonus : '';
            this.refCount = countObj ? countObj.Bonus : '';
          }
        },
        error: (error) => {
          this.apiCallService.handleError(error);
        },
      });
  }

  // Add this variable to your class
  isBannerVisible = true;

  // Add this function
  closeBanner(event: Event) {
    // This prevents the click from bubbling up to the button underneath
    event.stopPropagation();
    this.isBannerVisible = false;
  }

  gotoreflist() {
    this.showRefralModal = false;
    this.router.navigate(['dashboard/referallist']);
  }

  getDeviceOS(): 'iOS' | 'Android' | 'Desktop' {
    if (typeof window === 'undefined') return 'Desktop';

    const ua = navigator.userAgent || navigator.vendor;

    if (/android/i.test(ua)) {
      return 'Android';
    }

    if (
      /iPad|iPhone|iPod/i.test(ua) ||
      (ua.includes('Mac') && navigator.maxTouchPoints > 1)
    ) {
      return 'iOS';
    }

    return 'Desktop';
  }
  async checkAndRequest() {
    const os = this.getDeviceOS();
    const permission = Notification.permission;

    if (os === 'iOS') {
      // Show your custom Modal here
      this.utilService.triggerFirebaseFunction(true);
    }
  }
}
